import { Component, OnInit } from '@angular/core';
import { Risk } from "../../_interfaces/risk.model"; 
import { Router, ActivatedRoute } from '@angular/router';
import { formatDate } from '@angular/common';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RiskEvent } from "../../_interfaces/RiskEvent.model";
import { RepositoryService } from "../../shared/services/repository.service";
import { RiskPolicyGuideline } from "../../_interfaces/RiskPolicyGuideline.model";



@Component({
  selector: 'app-policy-guideline',
  templateUrl: './policy-guideline.component.html',
  styleUrls: ['./policy-guideline.component.css']
})
export class PolicyGuidelineComponent implements OnInit {
  riskPolicyGuidelineForm: FormGroup;
  submitted = false;
  fileData: File = null;
  id: string;

  public riskPolicyGuideline: RiskPolicyGuideline; 
 

  // public riskPolicyGuidelines: RiskPolicyGuideline[];

  constructor(private formBuilder: FormBuilder, private repository: RepositoryService,
    private router: Router,
    private activeRoute: ActivatedRoute) { }

  ngOnInit() {
    this.riskPolicyGuidelineForm = this.formBuilder.group({
      //eventId: ['', Validators.required],
      title: ['', Validators.required],
      audience: ['', Validators.required],
      filename: [''],
      approved: [''],
      approvalDate: ['', Validators.required],
      approvalReviewDate: ['', Validators.required],

      evidence: [File]
    });
    this.id = this.activeRoute.snapshot.params['id'];

    if (this.id === "0" ) {
      this.riskPolicyGuideline = new RiskPolicyGuideline();

    } else
    {
      this.getRiskPolicyGuidelineDetails();
    }

    
  }
  // convenience getter for easy access to form fields
  get f() { return this.riskPolicyGuidelineForm.controls; }

  getRiskPolicyGuidelineDetails() {
    let id: string = this.activeRoute.snapshot.params['id'];
    let apiUrl: string = `PolicyDocuments/${id}`;

    this.repository.getData(apiUrl)
      .subscribe(res => {
        this.riskPolicyGuideline = res as RiskPolicyGuideline;
        this.f.title.setValue(this.riskPolicyGuideline.title);
        this.f.audience.setValue(this.riskPolicyGuideline.audience);
        this.f.filename.setValue(this.riskPolicyGuideline.filename);
        this.f.approved.setValue(this.riskPolicyGuideline.approved);
        this.f.approvalDate.setValue(formatDate(this.riskPolicyGuideline.approvalDate, 'yyyy-MM-dd', 'en'));
        this.f.approvalReviewDate.setValue(formatDate(this.riskPolicyGuideline.approvalReviewDate, 'yyyy-MM-dd', 'en'));
        
      });
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!file.name.includes(".pdf")) {
        alert('Please select a pdf file with the Policy Guideline Details! :-)\n\n');
        return;
      }
      this.f.evidence.setValue(file);
      this.addPolicyGuidelineDocument(this.riskPolicyGuideline.id);
    }

  }
  addPolicyGuidelineDocument(id: number) {
    this.fileData = (this.f.evidence.value as File);
    let formData = new FormData();
    formData.append('file', this.fileData);
   
    let apiAddress: string = `PolicyDocuments/` + id + `/PolicyDocument`;

    this.repository.uploadFile(apiAddress, formData)
      .subscribe(res => {
        // Update the dialog contents
        this.getRiskPolicyGuidelineDetails();
      });; 
  }

  getPolicyGuidelineDocumentDetails(id: number) {
    let apiUrl: string = `PolicyDocuments/${id}/PolicyDocument`;
    this.repository.getFileData(apiUrl)
      .subscribe(res => {
        //  download file and open it
        var file = new Blob([res], { type: "application/pdf" });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, "Risk Policy Guideline.pdf");
        }
        else {
          var objectUrl = URL.createObjectURL(file);
          window.open(objectUrl);
        }
      });
  }

  onSubmit() {
    this.submitted = true;
    this.riskPolicyGuideline.title = this.f.title.value;
    this.riskPolicyGuideline.audience = this.f.audience.value;
    this.riskPolicyGuideline.approvalDate = this.f.approvalDate.value;
    this.riskPolicyGuideline.approvalReviewDate = this.f.approvalReviewDate.value;

    // Save updated Risk Policy Guideline here
    let apiAddress: string = `PolicyDocuments`;

    if (this.riskPolicyGuideline.id > 0) {
      this.repository.update(apiAddress, this.riskPolicyGuideline)
        .subscribe(res => {
            // this.riskPolicyGuideline = res as RiskPolicyGuideline;
          }, error => {
            //console.error("Error: ", error);
            // alert('Error:!' + error.message + '\n\n');
          },
          () => this.router.navigate(["../../policy-guidelines"], { relativeTo: this.activeRoute })
        );
    } else {
      this.repository.create(apiAddress, this.riskPolicyGuideline)
        .subscribe(res => {
            // this.riskPolicyGuideline = res as RiskPolicyGuideline;
          }, error => {
            //console.error("Error: ", error);
            // alert('Error:!' + error.message + '\n\n');
          },
          () => this.router.navigate(["../../policy-guidelines"], { relativeTo: this.activeRoute })
        );
    }


  }
  onCancelForm() {
    this.router.navigate(["../../policy-guidelines"], { relativeTo: this.activeRoute });
  }

}
